import { module } from 'modujs';
import { html } from '../utils/environment'

const CLASS = {
    OPEN: `has-nav-open`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                buttonClose: 'close'
            }
        }
    }

    init(){
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close();
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    toggle() {
        html.classList.contains(CLASS.OPEN) ? this.close() : this.open()
    }

    open() {
        html.classList.add(CLASS.OPEN)
        this.call('inview', null, 'NavCases')
    }

    close() {
        html.classList.remove(CLASS.OPEN)

        if(this.timeout !== undefined) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            this.call('close',null,'NavCases');
        }, 1200)
    }

    destroy() {
        document.removeEventListener('keyup', this.closeBind)
    }
}
